import { render, staticRenderFns } from "./IconSharp.vue?vue&type=template&id=c0b70c68&scoped=true"
import script from "./IconSharp.vue?vue&type=script&lang=js"
export * from "./IconSharp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b70c68",
  null
  
)

export default component.exports